<template>
  <div>
    <PageHeader :title="!isMobileDevice?'方針勉強会':''" class="main-form">
      <template #title-header-content>
        <div class="flex-1 flex justify-between items-center">
          <div></div>
          <div class="text-white">
            7：00～17：00 のみ感想文の入力が可能<br>（保存時にAIによる判定を行います）
          </div>
          <!-- 一覧 -->
          <div class="min-w-fit">
            <PrimaryButton class="" size="sm" text="感想文一覧" @click="$router.push({ name: 'StudyPolicyList' })">
              <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
              <Icon v-else iconName="ClipboardList" slot="before" class="h-4 w-4" />
            </PrimaryButton>
          </div>
        </div>
      </template>
    </PageHeader>

    <main class="absolute top-20 bottom-4 leading-8 w-full main-form mx-auto">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full w-full">
        <div v-if="list.length" class="rounded-md border border-gray-200 table-h overflow-auto bg-white p-2">
          <div class="flex flex-wrap justify-between">
            <div v-for="row in list" :key="row.movieId" class="mt-2 mx-auto p-2 mb-10 min-w-560">
              <!-- 期限 -->
              <div class="text-sm font-bold text-gray-700 mb-3">
                {{ row.period }}
              </div>

              <!-- URL -->
              <div class="mb-2">
                <!-- 視聴URL -->
                <div v-if="row.url&&row.url.indexOf('watch')>-1">
                  <a :href="row.url" target="_blank" rel="noopener noreferrer" class="p-1 text-blue-700 border-b border-blue-600">{{row.url}}</a>
                </div>
                <!-- 共有URL -->
                <div v-else-if="row.url" :id="'movie'+row.movieId" style=""></div>
              </div>

              <!-- 判定結果 -->
              <div v-if="row.res==1" class="text-green-700 font-bold flex justify-center my-1">
                <Icon iconName="CheckCircle" slot="before" class="h-6 w-6 self-center" />
                <div class="self-center">保存済み・有効です</div>
              </div>

              <!-- タイトル -->
              <div v-if="row.status&&row.status[0]">
                <div v-if="row.status[0].indexOf('OK')>-1" class="text-blue-600 text-sm font-bold">OK</div>
                <div v-else class="text-red-600 text-sm font-bold">NG</div>
              </div>
              <div v-else class="h-4"></div>
              <div class="mt-1 mb-2">
                <WmsTextInput
                  caption="タイトル（方針勉強会No...ではなく「●●に関する方針」等でお願いします）"
                  v-model="row.title"
                  class="rounded "
                />
              </div>

              <!-- 実施項目 -->
              <div v-if="row.status&&row.status[1]">
                <div v-if="row.status[1].indexOf('OK')>-1" class="text-blue-600 text-sm font-bold">OK</div>
                <div v-else class="text-red-600 text-sm font-bold">NG</div>
              </div>
              <div v-else class="h-4"></div>
              <div class="mt-1 mb-2">
                <WmsTextInput
                  caption="実施項目"
                  v-model="row.keyword"
                  class="rounded "
                />
              </div>

              <!-- 感想文 -->
              <div v-if="row.status&&row.status[2]">
                <div v-if="row.status[2].indexOf('OK')>-1" class="text-blue-600 text-sm font-bold">OK</div>
                <div v-else class="text-red-600 text-sm font-bold">NG</div>
              </div>
              <div v-else class="h-4"></div>
              <div class="text-xs font-bold text-gray-700 mt-1 mb-1">
                感想・決意表明をお書きください（具体的にお願いします）
              </div>
              <textarea
                :rows="5"
                class="border border-gray-300 w-full rounded"
                v-model="row.report"
              />

              <!-- 判定結果 -->
              <div v-if="row.res==1" class="text-green-700 font-bold flex justify-center">
                <Icon iconName="CheckCircle" slot="before" class="h-6 w-6 self-center" />
                <div class="self-center">保存済み・有効です</div>
              </div>

              <!-- 判定結果 -->
              <div v-if="row.res==0" class="text-red-700 font-bold flex justify-center">
                <Icon iconName="XCircle" slot="before" class="h-6 w-6 self-center" />
                <div class="self-center">保存済みですが無効です</div>
              </div>

              <!-- 保存ボタン -->
              <div class="p-1">
                <PrimaryButton
                  text="保存・有効無効の判定"
                  class="w-full"
                  :disabled="loading"
                  @click="save(row)"
                >
                <LoadingIcon v-if="loading" slot="before" class="h-5 w-5" />
                </PrimaryButton>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!loading && timeOut" class="w-full h-full flex justify-center items-center text-gray-600">
          時間外のため表示されません。
        </div>
        <div v-else-if="!loading && !list.length" class="w-full h-full flex justify-center items-center text-gray-400">
          <EmptyMessage
            iconName="Document"
            message="該当するデータはありません。"
          />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import EmptyMessage from '@components/EmptyMessage.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import LoadingIcon from '@assets/loading-circle.svg'
import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'
import * as chatwork from '@libs/chatwork'
import PageModel from '../../main/pages/PageModel.vue'

const ROW = { movieId: null, url: '', title: '', period: '', report: '' }

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    EmptyMessage,
    PrimaryButton,
    LoadingIcon,
    WmsTextInput
  },

  computed: {
    /**
     * スマホ
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * タブレット
     */
    isTabletDevice() {
      return utils.deviceInfo.isTablet
    },

    /**
     * ログインユーザー名
     */
    user() {
      return utils.deleteKana(this.$store.getters.user.user_name)
    },

    /**
     * 時間内か判定
     */
    timeOut() {
      let time = Number(moment().format('Hmm'))
      if (time >= 700 && time <= 1700) {
        return false
      } else {
        return true
      }
    }
  },

  data() {
    return {
      loading: false,
      // リスト
      list: utils.clone(ROW),
      // チャット情報
      chat: {}
    }
  },

  async created() {
    await this.getData()
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      if (this.timeOut) {
        return
      }
      this.loading = true
      const res = await backend.searchData('evaluation/getPolicyReport', { user: this.user, userId: this.$store.getters.user.id })
      if (res.data.data) {
        this.list = utils.clone(res.data.data)

        if (res.data.chat && res.data.chat.roomId) {
          this.chat = res.data.chat
        }
      }
      this.loading = false
      await this.parse()
    },

    /**
     * 共有URLの場合、HTMLに変換
     */
    async parse() {
      await utils.wait(500)
      for (let i = 0; i < this.list.length; i++) {
        const l = this.list[i]
        if (l.url && l.url.indexOf('embed') > -1) {
          let element = document.getElementById('movie' + l.movieId)
          element.insertAdjacentHTML('afterend', l.url)
        }
      }
    },

    /**
     * 保存
     * @param row 対象データ
     */
    async save(row) {
      // 改行、タブ、半角・全角スペース削除
      const title = row.title.replace(/\s+/g, "")
      const keyword = row.keyword.replace(/\s+/g, "")
      const report = row.report.replace(/\s+/g, "")
      if (!title) {
        await dialogs.showErrorDialog('タイトル未入力', 'タイトルを記入してください。')
        return
      }
      if (!keyword) {
        await dialogs.showErrorDialog('実施事項未入力', '実施事項を記入してください。')
        return
      }
      if (!report) {
        await dialogs.showErrorDialog('感想未入力', '感想を記入してください。')
        return
      } else if (report.length < 10) {
        await dialogs.showErrorDialog('感想が短すぎます', '具体的な感想文をお願いいたします。')
        return
      }

      if (row.res == 1) {
        const r = await dialogs.showConfirmDialog('有効・保存済み', 'すでに有効判定で保存しています。再度、判定を行いますか？')
        if (r != 'YES') {
          return
        }
      }
      this.loading = true
      // Gemini問い合わせプロンプト生成
      const gemini = []

      const g1 = '以下のついて判定して返却は、OKまたはNGのみ。\n' +
        '【正解】' +
        row.mstTitle +
        '【ユーザー入力】' +
        row.title + '\n' +
        '1. ユーザー入力、正解と同じ意味の語句が書かれていればOK。前後に数字、記号、ページ番号などがついていてもOK\n' +
        '2. 誤字があってもOK\n'

      // タイトル
      gemini.push(g1)

      // キーワード
      const g2 = '以下のついて判定して返却は、OKまたはNGのみ。\n' +
        '【正解】' +
        row.mstKeyword.join('、') +
        '【ユーザー入力】' +
        row.keyword + '\n' +
        '1. ユーザー入力、正解と同じ意味の語句が書かれていればOK。前後に数字、記号、ページ番号などがついていてもOK\n' +
        '2. 誤字があってもOK\n'

      gemini.push(g2)
      // gemini.push(`次の内容について、ユーザー入力が管理者の実施項目をすべて「意味として」含んでいるか判定してください。

      // 【正解の項目】
      // ${row.mstKeyword.join('、')}
      // （項目数: ${row.mstKeyword.length}）

      // 【ユーザー入力】
      // ${row.keyword}

      // ▼ 判定ルール ▼

      // 1. ユーザー入力から「項目らしきブロック」を抽出する。
      //   数字の有無・記号の種類は不問。
      //   以下のどれでも項目の区切りとみなす：
      //   ・数字 + 記号（例：1. 1・ 1) ① ）
      //   ・句読点（、 , .）
      //   ・改行
      //   ・スペース連続
      //   ・語の自然な切れ目

      // 2. 正解の項目数（${row.mstKeyword.length}）より、
      //   ユーザー側の“項目らしき語句”が明らかに少ない場合は NG。
      //   （ただしユーザー側に余計な語が混ざっていてもよい）

      // 3. 各正解項目について、
      //   ユーザー側のどこかに「意味的に対応する語」が含まれていれば OK とみなす。
      //   ・類義語 OK
      //   ・誤字・表記ゆれ OK
      //   ・部分一致 OK
      //   ・順番不問
      //   ・複合語（例：昇給・昇格）については構成要素のどれかを含んでいればよい

      // 4. 管理者の項目の意味が1つでも満たされていなければ NG。

      // 5. 出力は **OK または NG のみ**。理由・説明は書かない。`)

      const g3 = '以下を判定して返却は、OKまたはNGのみ。\n' +
        '【文章内容】ここから\n' +
        row.report +
        '【文章内容】ここまで\n' +
        '1、文章内容がふざけた文章ではないこと。誤字は許す。\n' +
        '2、挨拶だけ、はNG\n' +
        '3、「お元気様です」は社内の合言葉になっているので、これが含まれていてもOK\n' +
        '4、上記すべて満たしていればOK\n'
      
      gemini.push(g3)

      // 感想文
      // gemini.push(`以下を厳密に判定してください。

      // 【ユーザー入力】
      // ${row.report}

      // ▼ 判定基準 ▼

      // 1. 文章全体が「具体的な感想文または決意表明」として成立していること。
      //   ・内容に具体性がなく、形式だけ（例：「感想文」「よろしくお願いします」「頑張ります」など）なら NG。
      //   ・単語のみ、短すぎる文章も NG。
      //   ・10文字以下は内容に関係なく無条件で NG。

      // 2. 内容が「ふざけている」「ふまじめ」「意味をなさない」「AIを騙そうとしている」場合は NG。

      // 3. 一般的な挨拶（例：「お元気様です」「よろしくお願いいたします」など）が含まれていても問題ない。

      // 4. 全体として明らかに仕事上の真面目な文章であり、
      //   具体的な経験・感想・気づき・意志・学び・考察などが一定量含まれている場合のみ OK。

      // 5. 上記をすべて満たさない場合は NG。

      // 6. 出力は **OK または NG のみ**。説明や理由は書かない。`)
      console.log(gemini)

      const res = await backend.postData('evaluation/savePolicyReport', { ...row, user: this.user, userId: this.$store.getters.user.id, gemini })
      if (res && res.data.data) {
        row.id = res.data.data.id
      }
      row.status = res.data.geminiRes
      if (res.data.point == 0) {
        row.res = 0
        let msg = []
        if (row.status[0].indexOf('NG') > -1) {
          let titleNote = ''
          if (title.indexOf('方針勉強会') > -1) {
            titleNote = '（方針勉強会No...などではなく、「●●に関する方針」などでお願いします）'
          }
          msg.push('■タイトルが無効です。' + titleNote)
        }
        if (row.status[1].indexOf('NG') > -1) {
          let keyNote = ''
          if (row.mstKeyword.length > 1) {
            keyNote = '（ヒント：実施項目は' + row.mstKeyword.length + 'つです）'
          }
          msg.push('■実施項目が無効です。' + keyNote)
        }
        if (row.status[2].indexOf('NG') > -1) {
          msg.push('■感想文が無効です。（具体的に書いてください）')
        }
        alert('無効です。\r\n' + msg.join('\r\n'))
      } else if (res.data.point == -1) {
        alert('現在、アクセス集中でGemini判定できません。\r\n時間（30分ほど）をおいてから再度、保存を押してください。\r\n文章は保存しています。')
      } else {
        row.res = 1
        let chatFlg = false
        // チャット送信する場合
        if (this.chat && this.chat.roomId) {
          chatFlg = true
          // チャット送信
          let again = ''
          if (row.point == 1) {
            again = '（再送信）'
          }
          let message = `[info][title]${this.user} さんの感想文です${again}[/title]`
          message += `${this.user}  (${moment().format('M/D')})\r\n\r\n`
          message += 'タイトル：' + row.title + '\r\n'
          message += '実施項目：' + row.keyword + '\r\n'
          message += '\r\n'
          message += row.report
          message += '[/info]'
          await chatwork.sendChatWorkMssage(
            this.chat.roomId,
            message,
            this.chat.apiToken
          )
        }
        let msg = '保存しました。\r\nタイトル、実施項目、感想文、全て有効です。'
        if (chatFlg) {
          msg += '\r\nまた、チャット送信完了しました。'
        }
        await dialogs.showSuccessDialog('有効です', msg)
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.main-form {
  min-width: 650px;
}

.min-w-560 {
  min-width: 560px;
}
</style>